<template>
  <div class="basic-block" :style="'background-color:' + color">
    <icon
      :name="icon"
      customWidth="60"
      customHeight="60" />
    <div class="content">
      <h3>{{ title }}</h3>

      <btn
        :url="url"
        type="with-icon small"
        iconName="cog"
        iconColor="color-text-light">
        {{ $t('settingsBasicBlock.changeSettings') }}
      </btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'settings-basic-block',
  props: {
    title: {
      type: String
    },
    icon: {
      type: String
    },
    color: {
      type: String
    },
    url: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.basic-block {
  border-radius: $border-radius-small;
  display: flex;
  padding: 3.5rem 2.5rem;

  h3 {
    font-size: 2rem;
    font-weight: 400;
    line-height: 1;
    margin: .25rem 0 1rem 0;
  }

  .content {
    margin-left: 2.4rem;
  }

  .button {
    margin-left: 0;
  }
}

@media (max-width: 1600px) {
  .block {
    .basic-block {
      .content {
        h3 {
          font-size: 1.8rem;
        }
      }
    }
  }
}

@media (max-width: 1400px) {
  .block {
    .basic-block {
      .content {
        h3 {
          font-size: 1.5rem;
        }
      }
    }
  }
}

@media (max-width: 1240px) {
  .basic-block {
    flex-wrap: wrap;
    justify-content: center;
    padding: 2.5rem 1.5rem;

    & > .icon {
      margin-right: 2rem;
    }
  }

  .block {
    .basic-block {
      .content {
        margin-left: 0!important;
        text-align: center;

        h3 {
          font-size: 1.4rem;
          margin: 1rem 0;
        }

        .button {
          justify-content: center;
          width: 100%;
        }
      }
    }
  }
}

@media (max-width: 1180px) {
  .basic-block {
    & > .icon {
      margin-right: 0;
      width: 100%!important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/SettingsBasicBlock.vue